export default __webpack_public_path__ + "static/media/1989.ea92810b.png";